import {IWorkflowStepBase} from "./workflow-step-base.model";
import {WorkflowStep} from "../../enums/WorkflowStep";
import {PlateModel} from "../Plate/plate.model";
import {WorkflowInstanceModel} from "../workflow/workflow-instance.model";
import {BatchModel} from "../batch/batch.model";
import {IWorkflowStepValidation} from "./workflow-step-validation.model";
import {Workflow} from "../../enums/Workflow";

export class WorkflowStepDnaExtractionModel implements IWorkflowStepBase, IWorkflowStepValidation {

  id: number;
  step: WorkflowStep;
  workflowInstance: WorkflowInstanceModel;
  isSkipped: boolean;

  plates: PlateModel[];
  batches: BatchModel[];

  constructor(id: number, step: WorkflowStep, workflowInstance: WorkflowInstanceModel, plates: PlateModel[], batches: BatchModel[], isSkipped: boolean) {
    this.id = id;
    this.step = step;
    this.workflowInstance = workflowInstance;
    this.isSkipped = isSkipped;
    this.plates = plates?.map(PlateModel.fromData);
    this.batches = batches?.map(BatchModel.fromData);
  }

  isValid(): boolean {
    // valid if a plate exists and all batches have an expiration date set
    for (const batch of this.batches) {
      if (!batch.expirationDate) {
        return false;
      }
    }
    // check plate counter
    if (this.workflowInstance.workflow === Workflow.WORKFLOW_96) {
      return this.plates.length === 1 && this.plates.every(plate => plate?.id != null);
    } else {
      return this.plates.length === 4 && this.plates.every(plate => plate?.id != null);
    }
  }

}
